import { UncontrolledTooltip } from "reactstrap";
import Icon from "./Icon";

export default function ProspectStar({ className }) {
    return (
        <>
            <Icon name="star-fill" className={className ? className : 'text-azure'} style={{ marginLeft: '0.5rem' }} id={`user-prospect-star`} />
            <UncontrolledTooltip placement="top" target={`user-prospect-star`}>
                Prospect
            </UncontrolledTooltip>
        </>
    )
}